import React, { FC } from "react"
import { RouteComponentProps } from '@reach/router';
import { getEntity } from './permission.reducer';
import { connect } from 'react-redux';
import DetailsPage, { DetailsStateAndDispatchProps } from "layouts/page-wraper/details-page";
import { RootState } from "reducers";
import ProDescriptions from "@ant-design/pro-descriptions";
import { Permission } from "model/system/permission.model";

export interface PermissionDetailsProps extends DetailsStateAndDispatchProps<Permission>,
  RouteComponentProps, StateProps, DispatchProps {
}
const PermissionDetails: FC<PermissionDetailsProps> = (props) => {
  return (
    <DetailsPage<Permission>
      title={'详情'}
      hideEdit={true}
      {...props}
    >
      <ProDescriptions<Permission>
        columns={props.columns as any}
        dataSource={props.entity}
        column={2}
      >
      </ProDescriptions>

    </DetailsPage>);
};

const mapStateToProps = ({ permission }: RootState) => ({
  entity: permission.entity,
});

const mapDispatchToProps = {
  getEntity,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(PermissionDetails);
